import { Box } from '@chakra-ui/react';

import { Footer } from '$components/layout/footer';
import { Header } from '$components/layout/header';
import { CONTAINER_MAX_W, CONTAINER_PX } from '$shared/layout';

import { AboutMe } from './about-me';
import { Contact } from './contact';
import { Experience } from './experience';
import { Projects } from './projects';
import { Welcome } from './welcome';
import { Writing, WritingPost } from './writing';
import type { Project } from './projects';

export interface HomeTemplateProps {
  projects: Project[];
  posts: WritingPost[];
  techs: string[];
  about: string;
}

export function HomeTemplate({
  projects,
  posts,
  techs,
  about,
}: HomeTemplateProps) {
  return (
    <>
      <Header />

      <Welcome techs={techs} />

      <Box
        as="main"
        maxW={CONTAINER_MAX_W}
        mx="auto"
        px={CONTAINER_PX}
        pt={{ base: '24px', md: '40px' }}
        pb={{ base: '48px', md: '64px' }}
      >
        <AboutMe content={about} />
        <Experience />
        <Projects projects={projects} />
        <Writing posts={posts} />
        <Contact />

        <Footer />
      </Box>
    </>
  );
}
